import React, { useMemo } from "react";

/**
 * Ambient drifting bubbles behind the journey — moderate intensity, looped
 * via CSS (no per-frame React updates). Positions are randomized once on mount
 * and stable across re-renders so they don't restart on parent state changes.
 */
export default function SeaBubbles({ count = 18 }) {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = 6 + Math.random() * 22;           // 6–28 px
      const left = Math.random() * 100;              // % across viewport
      const duration = 14 + Math.random() * 16;      // 14–30 s rise
      const delay = -Math.random() * duration;       // negative for staggered start
      const drift = (Math.random() * 2 - 1) * 60;    // -60..60 px lateral drift
      const opacity = 0.55 + Math.random() * 0.35;
      return { i, size, left, duration, delay, drift, opacity };
    });
  }, [count]);

  return (
    <div className="sea-bubbles" aria-hidden="true" data-testid="sea-bubbles">
      {bubbles.map((b) => (
        <span
          key={b.i}
          className="sea-bubble"
          style={{
            width: b.size,
            height: b.size,
            left: `${b.left}%`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
            "--drift": `${b.drift}px`,
            "--peakOpacity": b.opacity,
          }}
        />
      ))}
    </div>
  );
}
